export default "__VITE_ASSET__CaXr4oPY__"